import { Deserializable } from '../../../lib/models/deserializable';

export class ExistingPropertyParticipant implements Deserializable {
  public ExistingPropertyParticipantID: number;
  public ExistingPropertyID?: number;
  public Name: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
